'use strict';

export function init() {
  const buttons = document.querySelectorAll('.seasonGridToggle');

  buttons.forEach(button => {
    button.addEventListener('click', function () {
      const extendedList = this.nextElementSibling;
      if (!extendedList) return;

      extendedList.classList.toggle('active');

      if (extendedList.classList.contains('active')) {
        this.style.display = 'none';
      }
    });
  });
}